import { useEffect } from "react";

// Keep native numeric validation, but make number fields behave like textboxes.
export const useNumberInputBehavior = () => {
  useEffect(() => {
    const onWheel = () => {
      const focused = document.activeElement;
      if (focused instanceof HTMLInputElement && focused.type === "number") {
        // Blur before the browser steps the value; allow normal page scrolling.
        focused.blur();
      }
    };
    const onKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.type === "number" &&
          (event.key === "ArrowUp" || event.key === "ArrowDown")) {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", onWheel, { capture: true, passive: true });
    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      document.removeEventListener("wheel", onWheel, true);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, []);
};
